<template>
    <div class="edit js">
        <div class="edit-content" v-if="!loading && blogsList && blogsList.length > 0">
            <div class="width--content" data-animate data-animate-order="1" v-for="(item, index) in blogsList"
                :key="index">
                <div class="blog-post-card__header">
                    <div class="blog-post-card__meta">{{ item?.created_at_text }}</div>
                    <router-link :to="`/theEditDetail/${item.id}`" style="text-decoration: none;">
                        <h5 class="blog-post-card__title">{{ item?.title }}</h5>
                    </router-link>
                </div>
                <div class="blog-post-card__excerpt">
                    <p v-html="item?.des"></p>
                </div>
                <div class="text-link-animated">
                    <router-link :to="`/theEditDetail/${item.id}`">
                        {{ $t('new.readMore') }}
                    </router-link>
                </div>
            </div>

            <!-- <div class="width--content" data-animate data-animate-order="1">
                <div class="blog-post-card__header">
                    <div class="blog-post-card__meta">October 3, 2025</div>
                    <router-link to="/theEditDetail" style="text-decoration: none;">
                        <h5 class="blog-post-card__title">Test</h5>
                    </router-link>
                </div>
                <div class="blog-post-card__excerpt">
                    <p>testesw

                        testeswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtestesw
                    </p>
                </div>
                <div class="text-link-animated">
                    <router-link to="/theEditDetail">
                        Read more
                    </router-link>
                </div>
            </div> -->
        </div>
        <!-- <div v-else class="empty-height">
            <h2 style="text-align: center;">暂无数据</h2>
        </div> -->
        <!-- 加载中占位符 -->
        <div v-else class="loading-placeholder">
            <div class="skeleton-card" v-for="i in 1" :key="i">
                <div class="skeleton-meta"></div>
                <div class="skeleton-title"></div>
                <div class="skeleton-content">
                    <div class="skeleton-text long"></div>
                    <div class="skeleton-text"></div>
                    <div class="skeleton-text long"></div>
                </div>
                <div class="skeleton-link"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { getBannerListing, getNewsList } from '@/api/komo'
export default {
    data () {
        return {
            bannerList: [],
            blogsList: [],
            loading: true // 添加加载状态
        }
    },
    async created () {
        await this.initData();
    },
    methods: {
        async initData () {
            try {
                this.loading = true; // 开始加载

                //目前页面没有banner图
                // const result = await getBannerListing('7');
                // this.bannerList = result?.data?.list || [];
                // console.log('Banner数据:', this.bannerList);
                let params = {
                    type: '',
                    search: ''
                }
                const blogsDataList = await getNewsList(params);
                this.blogsList = blogsDataList.data.list;
                console.log('blogsData:', this.blogsList);
            } catch (error) {
                console.error('数据加载失败:', error);
                this.blogsList = []; // 出错时清空列表
            } finally {
                this.loading = false; // 加载完成
                this.initIntersectionObserver()
            }
        },
        initIntersectionObserver () {
            this.$nextTick(() => {
                const textElements = this.$el.querySelectorAll('[data-animate]');
                const allElements = [...textElements];
                if (allElements.length > 0) {
                    textElements.forEach(element => {
                        element.classList.remove('animate-trigger');
                    });


                    // 创建交叉观察器
                    const observer = new IntersectionObserver((entries) => {
                        entries.forEach(entry => {
                            const element = entry.target;

                            if (entry.isIntersecting) {
                                if (element.hasAttribute('data-animate')) {
                                    // 添加动画触发类
                                    element.classList.add('animate-trigger');
                                }

                            } else {
                                // 元素离开视口（支持重复动画）
                                if (element.hasAttribute('data-animate')) {
                                    element.classList.remove('animate-trigger');
                                }
                            }
                        });
                    }, {
                        threshold: 0.1, // 当10%的元素可见时触发
                        rootMargin: '0px 0px -50px 0px' // 提前50px触发
                    });

                    // 开始观察所有元素
                    allElements.forEach(element => {
                        observer.observe(element);
                    });
                }
            });
        }
    },
    mounted () {

    },
}
</script>
<style scoped>
.edit {
    padding: var(--nav-max-height) 0 0;
    display: block;
}

.edit-content {
    padding: 60px;
    color: #422b20;
    width: 100%;
    overflow: hidden;
    min-height: calc(100vh - var(--nav-max-height) - var(--nav-max-bottom-height));
}

.empty-height {
    height: calc(100vh - var(--nav-max-height) - var(--nav-max-bottom-height));
    display: flex;
    align-items: center;
    justify-content: center;
}

.width--content {
    max-width: 1600px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 30px;

}

.blog-post-card__header:not(:last-child) {
    margin-bottom: 10px;
}

.blog-post-card__header {
    display: flex;
    flex-direction: column;

}

.blog-post-card__meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 2px;
    font-size: 12px;
    opacity: .7;
}

.blog-post-card__title {
    font-size: 28px;
    margin: 0;
    font-family: var(--header-font-stack);
    color: #422b20;

}

.blog-post-card__excerpt:not(:last-child) {
    margin-bottom: 10px;
}

.blog-post-card__excerpt {
    font-size: 15px;
    line-height: 1.6;
    font-family: var(--label-font-stack);
}

.blog-post-card__excerpt p:last-child {
    margin-bottom: 0;
}

.text-link-animated a {
    display: inline;
    text-decoration: none;
    position: relative;
    /* background: linear-gradient(to top,var(--link-border-color) 0,var(--link-border-color) 0),linear-gradient(to top,currentColor 0,currentColor 0); */
    background-size: 100% 1px, 0 1px;
    background-position: 100% 100%, 0 100%;
    background-repeat: no-repeat;
    transition-property: background-size;
    transition-timing-function: ease;
    transition-duration: .25s;
    font-size: 15px;
    color: #223d33;

}

.loading-placeholder {
    padding: 60px;
    width: 100%;
    min-height: calc(100vh - var(--nav-max-height) - var(--nav-max-bottom-height));
}

.skeleton-card {
    max-width: 1600px;
    margin: 0 auto 30px;
    padding: 20px;
}

.skeleton-meta {
    width: 120px;
    height: 12px;
    background: #f0f0f0;
    margin-bottom: 15px;
    border-radius: 4px;
    animation: skeleton-loading 1.5s infinite;
}

.skeleton-title {
    width: 60%;
    height: 28px;
    background: #f0f0f0;
    margin-bottom: 15px;
    border-radius: 4px;
    animation: skeleton-loading 1.5s infinite;
}

.skeleton-content {
    margin-bottom: 15px;

    .skeleton-text {
        width: 100%;
        height: 16px;
        background: #f0f0f0;
        margin-bottom: 10px;
        border-radius: 4px;
        animation: skeleton-loading 1.5s infinite;

        &.long {
            width: 90%;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }
}

.skeleton-link {
    width: 80px;
    height: 16px;
    background: #f0f0f0;
    border-radius: 4px;
    animation: skeleton-loading 1.5s infinite;
}

@keyframes skeleton-loading {
    0% {
        background-color: #f0f0f0;
    }

    50% {
        background-color: #e0e0e0;
    }

    100% {
        background-color: #f0f0f0;
    }
}

@media (max-width: 768px) {
    .loading-placeholder {
        padding: 15px;
    }

    .skeleton-card {
        padding: 15px;
    }
}

@media (max-width: 768px) {
    .edit-content {
        padding: 15px;
        height: auto;
    }
}

@media (max-width: 1115px) {
    .edit {
        padding: var(--nav-1115-height) 0 0;
    }
}

@media (max-width: 990px) {
    .edit {
        padding: var(--nav-990-height) 0 0;
    }
}
</style>